<template>
	<div class="home">
		<div class="home__header">
			<AppHeader
				class="container"
				v-show="!$route.meta.headless"
			/>
		</div>
		<div class="home__views">
			<router-view
				class="view"
				:class="{ 'container' : !$route.meta.origin }"
			/>
			<div
				class="home__footer"
				:class="{'with-origin' : $route.meta.origin !== undefined}"
			>
				<AppFooter
					class="container"
					v-show="!$route.meta.headless"
				/>
			</div>
		</div>
		<AppNotificationBanner :visible="bannerStatus" />
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	async mounted () {
		await this.$nextTick()
		this.$emit('mounted')
	},

	computed: {
		...mapState({
			bannerStatus: state => state.banner.status
		})
	}
}
</script>

<style lang="scss" scoped>
.home {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: #F5F6FA;
    font-size: 12px;
    text-align: left;

	&__header {
		background-color: #FFF;
	}

	&__views {
		flex: 1 1 auto;
		overflow: auto;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	&__footer {
		width: 100%;
		display: flex;
		align-items: center;

		&.with-origin { padding-left: 60px; }
	}

}
</style>
